module.exports = __webpack_public_path__ + "img/N234-2.f100fb58.png";